import { mergeIconColorVars as e } from "../icon-props.js";
import { jsx as t, jsxs as n } from "react/jsx-runtime";
//#region src/icons/bundle-remove.tsx
function r({ colors: r, style: i, ...a }) {
	return /* @__PURE__ */ n("svg", {
		viewBox: "0 0 24 24",
		fill: "none",
		"aria-hidden": "true",
		focusable: "false",
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			...e(r),
			...i
		},
		...a,
		children: [
			/* @__PURE__ */ t("path", {
				d: "M4.00037 3.00012C4.00037 2.44784 3.55266 2.00012 3.00037 2.00012C2.44809 2.00012 2.00037 2.44784 2.00037 3.00012V21.0001C2.00037 21.5524 2.44809 22.0001 3.00037 22.0001C3.55265 22.0001 4.00037 21.5524 4.00037 21.0001V3.00012Z",
				fill: "var(--icon-color-primary, currentColor)"
			}),
			/* @__PURE__ */ t("path", {
				d: "M7.00037 3.00012C7.00037 2.44784 6.55266 2.00012 6.00037 2.00012C5.44809 2.00012 5.00037 2.44784 5.00037 3.00012V21.0001C5.00037 21.5524 5.44809 22.0001 6.00037 22.0001C6.55265 22.0001 7.00037 21.5524 7.00037 21.0001V3.00012Z",
				fill: "var(--icon-color-primary, currentColor)"
			}),
			/* @__PURE__ */ t("path", {
				d: "M9.00037 2.00012C9.55266 2.00012 10.0004 2.44784 10.0004 3.00012V21.0001C10.0004 21.5524 9.55265 22.0001 9.00037 22.0001C8.44809 22.0001 8.00037 21.5524 8.00037 21.0001V3.00012C8.00037 2.44784 8.44809 2.00012 9.00037 2.00012Z",
				fill: "var(--icon-color-primary, currentColor)"
			}),
			/* @__PURE__ */ t("path", {
				d: "M12.8721 4.50984C12.6013 4.02849 11.9916 3.85776 11.5102 4.12853C11.0289 4.39929 10.8582 5.00901 11.1289 5.49037L20.1289 21.4904C20.3997 21.9717 21.0094 22.1424 21.4908 21.8717C21.9721 21.6009 22.1428 20.9912 21.8721 20.5098L12.8721 4.50984Z",
				fill: "var(--icon-color-primary, currentColor)"
			}),
			/* @__PURE__ */ t("circle", {
				cx: "18",
				cy: "18",
				r: "5",
				fill: "var(--icon-color-on, var(--color-icon-on, white))",
				stroke: "var(--icon-color-primary, currentColor)",
				strokeWidth: "1.5"
			}),
			/* @__PURE__ */ t("path", {
				d: "M16 18H20",
				stroke: "var(--icon-color-primary, currentColor)",
				strokeWidth: "1.5",
				strokeLinecap: "round"
			})
		]
	});
}
//#endregion
export { r as BundleRemoveIcon };
